module.exports = __webpack_public_path__ + "img/task.2d8f2f3d.svg";